import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { listSchedulerConfigs, saveSchedulerConfig } from "../../api/attendanceApi";
import "../Users/UsersPage.css";

const JOB_TYPES = [
  { value: "STUDENT_ATTENDANCE", label: "Student Attendance" },
  { value: "TEACHER_ATTENDANCE", label: "Staff Attendance" },
];

/**
 * Per-institute daily auto-run time for the device-log attendance job (see
 * DeviceAttendanceLog javadoc in the backend for why this replaced
 * digicampusbd's four job types — STUDENT_ATTENDANCE/TEACHER_ATTENDANCE plus
 * their "ZK_" duplicates — with these same two).
 */
export default function SchedulerConfigPage() {
  const [configs, setConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [form, setForm] = useState({ jobType: "STUDENT_ATTENDANCE", runTime: "", activeStatus: true });

  const load = () => {
    setLoading(true);
    listSchedulerConfigs()
      .then(setConfigs)
      .catch(() => setError("Failed to load scheduler configuration."))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await saveSchedulerConfig(form);
      setSuccess("Scheduler configuration saved.");
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to save.");
    }
  };

  const columns = [
    { key: "jobType", label: "Job" },
    { key: "runTime", label: "Run Time" },
    { key: "activeStatus", label: "Active", render: (row) => (row.activeStatus ? "Yes" : "No") },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Attendance Scheduler</h1>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      <p>
        Configure a daily automatic time to compute attendance from whatever device punch data has been uploaded so
        far that day (same matching logic as "Process Device Data" on the attendance pages).
      </p>

      <form onSubmit={handleSubmit} className="user-form" style={{ marginBottom: 24 }}>
        <label>Job</label>
        <select value={form.jobType} onChange={(e) => setForm({ ...form, jobType: e.target.value })}>
          {JOB_TYPES.map((j) => (
            <option key={j.value} value={j.value}>
              {j.label}
            </option>
          ))}
        </select>
        <label>Run Time *</label>
        <input type="time" value={form.runTime} onChange={(e) => setForm({ ...form, runTime: e.target.value })} required />
        <label style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: "normal" }}>
          <input type="checkbox" checked={form.activeStatus} onChange={(e) => setForm({ ...form, activeStatus: e.target.checked })} />
          Active
        </label>
        <div className="form-actions">
          <button type="submit" className="btn-primary">
            Save
          </button>
        </div>
      </form>

      {loading ? <p>Loading...</p> : <DataTable columns={columns} rows={configs} />}
    </MainLayout>
  );
}
